<template>
  <div>
    <hshead title page="true" pic="false" BgHeight="4.28rem"></hshead>
    <router-link to="" class="more-head">
      <div class="left-pic">
        <img src="../assets/images/more/pic.png" alt />
      </div>
      <div class="center-p">去拍拍官当自营店</div>
      <div class="right-arr">
        <img src="../assets/images/more/r.png" alt />
      </div>
    </router-link>
    <div class="more-center">
      <div class="center-top">
        <div class="left-p">我的订单</div>
        <router-link to="" class="right-p">全部订单</router-link>
      </div>
      <div class="center-ul">
        <router-link to="" class="center-li">
          <div class="this-img">
            <img src="../assets/images/more/u1.png" alt />
          </div>
          <div class="this-p">待分配</div>
        </router-link>
        <router-link to="" class="center-li">
          <div class="this-img">
            <img src="../assets/images/more/u2.png" alt />
          </div>
          <div class="this-p">待审核</div>
        </router-link>
        <router-link to="" class="center-li">
          <div class="this-img">
            <img src="../assets/images/more/u3.png" alt />
          </div>
          <div class="this-p">打回</div>
        </router-link>
        <router-link to="" class="center-li">
          <div class="this-img">
            <img src="../assets/images/more/u4.png" alt />
          </div>
          <div class="this-p">已完成</div>
        </router-link>
        <router-link to="" class="center-li">
          <div class="this-img">
            <img src="../assets/images/more/u5.png" alt />
          </div>
          <div class="this-p">验收不通过</div>
        </router-link>
      </div>
    </div>
    <div class="more-dl">
      <router-link to="" class="more-li">
        <div class="left-img">
          <img src="../assets/images/more/d1.png" style="width:0.41rem" alt />
        </div>
        <div class="this-p">店铺客户</div>
        <div class="right-arr">
          <img src="../assets/images/more/r-g.png" alt />
        </div>
      </router-link>
      <router-link to="" class="more-li">
        <div class="left-img">
          <img src="../assets/images/more/d2.png"  style="width:0.38rem" alt />
        </div>
        <div class="this-p">报表中心</div>
        <div class="right-arr">
          <img src="../assets/images/more/r-g.png" alt />
        </div>
      </router-link>
      <router-link to="" class="more-li">
        <div class="left-img">
          <img src="../assets/images/more/d3.png"  style="width:0.29rem" alt />
        </div>
        <div class="this-p">用户中心</div>
        <div class="right-arr">
          <img src="../assets/images/more/r-g.png" alt />
        </div>
      </router-link>
      <router-link to="" class="more-li">
        <div class="left-img">
          <img src="../assets/images/more/d4.png"  style="width:0.38rem" alt />
        </div>
        <div class="this-p">关于我们</div>
        <div class="right-arr">
          <img src="../assets/images/more/r-g.png" alt />
        </div>
      </router-link>
    </div>
    <van-tabbar v-model="active">
      <van-tabbar-item to="/MissionHall" icon="todo-list-o">任务中心</van-tabbar-item>
      <van-tabbar-item icon="chart-trending-o">收益</van-tabbar-item>
      <van-tabbar-item icon="manager-o">摄影师</van-tabbar-item>
      <van-tabbar-item icon="orders-o">商品管理</van-tabbar-item>
      <van-tabbar-item icon="apps-o">更多</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import { Tabbar, TabbarItem } from "vant";

export default {
  name: "more",
  data() {
    return {
      active: 4,
      loading: false,
      finished: false
    };
  },
  components: {
    hshead,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/common.less";
@import "../assets/less/mixin.less";
.more-head {
  margin-top: -3.3rem;
  display: flex;
  padding: 0 0.51rem 0 0.45rem;
  align-items: center;
  height: 1.33rem;
  .left-pic {
    width: 1.33rem;
    height: 1.33rem;
    background-image: linear-gradient(135deg, #66cafa 0%, #4094f7 100%),
      linear-gradient(#ffffff, #ffffff);
    background-blend-mode: normal, normal;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 1.33rem;
      height: auto;
    }
  }
  .center-p {
    padding-left: 0.3rem;
    flex: 1;
    font-family: PingFang-SC-Medium;
    font-size: 0.34rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    color: #ffffff;
  }
  .right-arr {
    width: 0.32rem;
    img {
      width: 0.32rem;
    }
  }
}
.more-center {
  width: 7rem;
  height: 2.58rem;
  background-color: #ffffff;
  box-shadow: 0rem 0rem 0.24rem 0rem rgba(101, 176, 249, 0.41);
  border-radius: 0.2rem;
  margin-left: 0.25rem;
  margin-top: 0.5rem;
  .center-top {
    height: 0.78rem;
    line-height: 0.78rem;
    display: flex;
    border-bottom: 1px solid #eef2f5;
    .left-p {
      width: 4rem;
      font-family: PingFang-SC-Medium;
      font-size: 0.26rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0rem;
      color: #333333;
      padding-left: 0.37rem;
      display: block;
    }
    .right-p {
      flex: 1;
      font-family: PingFang-SC-Medium;
      font-size: 0.22rem;
      font-weight: normal;
      display: block;
      font-stretch: normal;
      letter-spacing: 0rem;
      color: #808d9e;
      text-align: right;
      padding-right: 0.3rem;
    }
  }
  .center-ul {
    display: flex;
    .center-li {
      width: 100/5 * 1%;
      text-align: center;
      display: block;
      .this-img {
        img {
          width: 0.6rem;
          display: inline-block;
        }
      }
      .this-p {
        font-family: PingFang-SC-Medium;
	font-size: 0.26rem;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0rem;
	color: #333333;
      }
    }
  }
}
.more-dl {
  padding: 0.3rem 0.25rem 0 0.4rem;
  .more-li {
    width: 7.5-0.25-0.4rem;
    height: 0.9rem;
    display: flex;
    align-items: center;
    .left-img {
      width: 0.6rem;
      img {
      }
    }
    .this-p {
      font-family: PingFang-SC-Medium;
      font-size: 0.28rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0rem;
      color: #666666;
      flex: 1;
    }
    .right-arr {
      width: 0.3rem;
      img {
        width: 0.12rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/more.vue